import { Form } from "react-bootstrap";
import type { FormInt, Interrogatory } from "@/briefpoint-client";
import { sanitizeHtmlString } from "@/utils";
import styles from "./InterrogatoriesListItem.module.scss";

interface InterrogatoriesListItemProps {
  interrogatory: Interrogatory;
  displayNumber: number;
  isSelected: boolean;
  disabled: boolean;
  onToggle: () => void;
  formInt: FormInt | null;
}

export default function InterrogatoriesListItem(
  props: InterrogatoriesListItemProps,
) {
  const hasResponse =
    props.interrogatory.responseList &&
    Object.keys(props.interrogatory.responseList).length > 0;

  const responseText =
    hasResponse && props.interrogatory.responseList
      ? Object.values(props.interrogatory.responseList)
          .flat()
          .map((item) => item.additionalText)
          .filter(Boolean)
          .join("\n")
      : null;

  // For FROGS, use FormInt displayName and text instead of interrogatory data
  const interrogatoryNumber = props.formInt?.displayName ?? props.displayNumber;
  const interrogatoryText = props.formInt?.text ?? props.interrogatory.text;

  return (
    <div
      id={`interrogatory-${props.interrogatory.id}`}
      className={styles.interrogatoryListItem}
    >
      <div className={styles.interrogatoryHeader}>
        <Form.Check
          type="checkbox"
          checked={props.isSelected}
          onChange={props.onToggle}
          disabled={props.disabled}
          id={`interrogatory-checkbox-${props.interrogatory.id}`}
        />
        <div className={styles.interrogatoryNumber}>
          Interrogatory {interrogatoryNumber}
        </div>
      </div>
      <div className={styles.body}>
        <div
          className={styles.interrogatoryText}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: html is from our server
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlString(interrogatoryText ?? ""),
          }}
        />

        {hasResponse && responseText && (
          <div className={styles.responseSection}>
            <div className={styles.responseLabel}>
              Response to Interrogatory No. {interrogatoryNumber}
            </div>
            <div
              className={styles.responseText}
              // biome-ignore lint/security/noDangerouslySetInnerHtml: html is from our server
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlString(responseText),
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
